import { FilterOption, instanceOfFilterOption, SegmentationOption } from '@salecycle/experimental/types/types';
import { allIataCodes } from './IataCodeConstants';
import { allCountries } from 'models/utils/countries';

const iataCodes: string[] = ['LHR'];
const countryCodes: string[] = [
  'AD',
  'AE',
  'AF',
  'AG',
  'AI',
  'AL',
  'AM',
  'AN',
  'AO',
  'AR',
  'AS',
  'AT',
  'AU',
  'AW',
  'AX',
  'AZ',
  'BA',
  'BB',
  'BD',
  'BE',
  'BF',
  'BG',
  'BH',
  'BI',
  'BJ',
  'BL',
  'BM',
  'BN',
  'BO',
  'BQ',
  'BR',
  'BS',
  'BT',
  'BV',
  'BW',
  'BY',
  'BZ',
  'CA',
  'CC',
  'CD',
  'CF',
  'CG',
  'CH',
  'CI',
  'CK',
  'CL',
  'CM',
  'CN',
  'CO',
  'CR',
  'CU',
  'CV',
  'CW',
  'CX',
  'CY',
  'CZ',
  'DE',
  'DJ',
  'DK',
  'DM',
  'DO',
  'DZ',
  'EC',
  'EE',
  'EG',
  'EH',
  'ER',
  'ES',
  'ET',
  'FI',
  'FJ',
  'FK',
  'FM',
  'FO',
  'FR',
  'GA',
  'GB',
  'GD',
  'GE',
  'GF',
  'GG',
  'GH',
  'GI',
  'GL',
  'GM',
  'GN',
  'GP',
  'GQ',
  'GR',
  'GS',
  'GT',
  'GU',
  'GW',
  'GY',
  'HK',
  'HM',
  'HN',
  'HR',
  'HT',
  'HU',
  'ID',
  'IE',
  'IL',
  'IM',
  'IN',
  'IO',
  'IQ',
  'IR',
  'IS',
  'IT',
  'JE',
  'JM',
  'JO',
  'JP',
  'KE',
  'KG',
  'KH',
  'KI',
  'KM',
  'KN',
  'KP',
  'KR',
  'KW',
  'KY',
  'KZ',
  'LA',
  'LB',
  'LC',
  'LI',
  'LK',
  'LR',
  'LS',
  'LT',
  'LU',
  'LV',
  'LY',
  'MA',
  'MC',
  'MD',
  'ME',
  'MF',
  'MG',
  'MH',
  'MK',
  'ML',
  'MM',
  'MN',
  'MO',
  'MP',
  'MQ',
  'MR',
  'MS',
  'MT',
  'MU',
  'MV',
  'MW',
  'MX',
  'MY',
  'MZ',
  'NA',
  'NC',
  'NE',
  'NF',
  'NG',
  'NI',
  'NL',
  'NO',
  'NP',
  'NPR',
  'NR',
  'NU',
  'NZ',
  'OM',
  'PA',
  'PE',
  'PF',
  'PG',
  'PH',
  'PK',
  'PL',
  'PM',
  'PN',
  'PR',
  'PS',
  'PT',
  'PW',
  'PY',
  'QA',
  'RE',
  'RO',
  'RS',
  'RU',
  'RW',
  'SA',
  'SB',
  'SC',
  'SD',
  'SE',
  'SG',
  'SH',
  'SI',
  'SJ',
  'SK',
  'SL',
  'SM',
  'SN',
  'SO',
  'SR',
  'ST',
  'SV',
  'SX',
  'SY',
  'SZ',
  'TC',
  'TD',
  'TF',
  'TG',
  'TH',
  'TJ',
  'TK',
  'TL',
  'TM',
  'TN',
  'TO',
  'TR',
  'TT',
  'TV',
  'TW',
  'TZ',
  'UA',
  'UG',
  'UM',
  'US',
  'UY',
  'UZ',
  'VA',
  'VC',
  'VE',
  'VG',
  'VI',
  'VN',
  'VU',
  'WF',
  'WS',
  'YE',
  'YT',
  'ZA',
  'ZM',
  'ZW',
];

export const OPERATORS_TRANSLATION_PREFIX_DEFAULT = 'segmentationRules.conditions';
export const VALUES_TRANSLATION_PREFIX_DEFAULT = 'segmentationRules.values';

const defaultStringFilter: FilterOption = {
  operators: ['=', '!=', 'includes', '!includes'],
  values: [],
  defaultOperator: '=',
  defaultValue: '',
  filterType: 'string',
};

const defaultStockFilter: FilterOption = {
  operators: [],
  values: ['true', 'false'],
  defaultOperator: '',
  defaultValue: 'true',
  filterType: 'bool',
};

// We can trust that all lowest level string key is a unique path in the compilation context
// like 'abandonedBasket.items.*.product.url' so they never repeat within the same options definition object

export const browseECommerce: SegmentationOption = {
  stock: {
    'browsedProducts.*.product.name': defaultStringFilter,
    'browsedProducts.*.product.category.id': defaultStringFilter,
    'browsedProducts.*.product.id': defaultStringFilter,
    'browsedProducts.*.product.url': defaultStringFilter,
    'browsedProducts.*.product.inStock': defaultStockFilter,
    'browsedProducts.*.product.isLowStock': defaultStockFilter,
  } as SegmentationOption,
} as SegmentationOption;

const defaultNumericFilter: FilterOption = {
  operators: ['>', '>=', '=', '<=', '<'],
  values: [],
  defaultOperator: '>',
  defaultValue: '',
  filterType: 'number',
  operatorsTranslationPrefix: 'segmentationRules.conditionsNumeric',
};

export const basketECommerce: SegmentationOption = {
  basket: {
    'abandonedBasket.source': defaultStringFilter,
    'abandonedBasket.type': defaultStringFilter,
    'abandonedBasket.costs.subtotal.decimal': defaultNumericFilter,
    'abandonedBasket.repopulationUrl': defaultStringFilter,
    'abandonedBasket.shipping.address.country': {
      operators: ['=', '!='],
      values: Object.keys(allCountries),
      valuesTranslationPrefix: 'geolocation.countryNames',
      defaultOperator: '=',
      defaultValue: countryCodes[0],
      filterType: 'array',
    } as FilterOption,
  },
  stock: {
    'abandonedBasket.items.*.product.name': defaultStringFilter,
    'abandonedBasket.items.*.product.category.id': defaultStringFilter,
    'abandonedBasket.items.*.product.id': defaultStringFilter,
    'abandonedBasket.items.*.product.url': defaultStringFilter,
    'abandonedBasket.items.*.product.inStock': defaultStockFilter,
    'abandonedBasket.items.*.product.isLowStock': defaultStockFilter,
  } as SegmentationOption,
  travel: {
    'abandonedBasket.items.*.product.journey.*.start.where.iataCode': {
      operators: ['=', '!='],
      values: Object.keys(allIataCodes),
      valuesTranslationPrefix: 'journey.iataCodes',
      defaultOperator: '=',
      defaultValue: iataCodes[0],
      filterType: 'array',
    } as FilterOption,
  } as SegmentationOption,
} as SegmentationOption;

export const purchaseECommerce: SegmentationOption = {
  basket: {
    'purchasedBasket.source': defaultStringFilter,
    'purchasedBasket.type': defaultStringFilter,
    'purchasedBasket.costs.subtotal.decimal': defaultNumericFilter,
    'purchasedBasket.repopulationUrl': defaultStringFilter,
    'purchasedBasket.shipping.address.country': {
      operators: ['=', '!='],
      values: Object.keys(allCountries),
      valuesTranslationPrefix: 'geolocation.countryNames',
      defaultOperator: '=',
      defaultValue: countryCodes[0],
      filterType: 'array',
    } as FilterOption,
  },
  stock: {
    'purchasedBasket.items.*.product.name': defaultStringFilter,
    'purchasedBasket.items.*.product.category.id': defaultStringFilter,
    'purchasedBasket.items.*.product.id': defaultStringFilter,
    'purchasedBasket.items.*.product.url': defaultStringFilter,
    'purchasedBasket.items.*.product.inStock': defaultStockFilter,
    'purchasedBasket.items.*.product.isLowStock': defaultStockFilter,
  } as SegmentationOption,
  travel: {
    'purchasedBasket.items.*.product.journey.*.start.where.iataCode': {
      operators: ['=', '!='],
      values: Object.keys(allIataCodes),
      valuesTranslationPrefix: 'journey.iataCodes',
      defaultOperator: '=',
      defaultValue: iataCodes[0],
      filterType: 'array',
    } as FilterOption,
  } as SegmentationOption,
} as SegmentationOption;

const mutualeCommerce = {
  basket: {
    'abandonedBasket.source': defaultStringFilter,
    'abandonedBasket.type': defaultStringFilter,
    'abandonedBasket.costs.subtotal.decimal': defaultNumericFilter,
    'abandonedBasket.repopulationUrl': defaultStringFilter,
    'abandonedBasket.shipping.address.country': {
      operators: ['=', '!='],
      values: Object.keys(allCountries),
      valuesTranslationPrefix: 'geolocation.countryNames',
      defaultOperator: '=',
      defaultValue: countryCodes[0],
      filterType: 'array',
    } as FilterOption,
  },
  stock: {
    'abandonedBasket.items.*.product.name': defaultStringFilter,
    'abandonedBasket.items.*.product.category.id': defaultStringFilter,
    'abandonedBasket.items.*.product.id': defaultStringFilter,
    'abandonedBasket.items.*.product.url': defaultStringFilter,
    'abandonedBasket.items.*.product.inStock': defaultStockFilter,
    'abandonedBasket.items.*.product.isLowStock': defaultStockFilter,
    'browsedProducts.*.product.name': defaultStringFilter,
    'browsedProducts.*.product.category.id': defaultStringFilter,
    'browsedProducts.*.product.id': defaultStringFilter,
    'browsedProducts.*.product.url': defaultStringFilter,
    'browsedProducts.*.product.inStock': defaultStockFilter,
    'browsedProducts.*.product.isLowStock': defaultStockFilter,
  } as SegmentationOption,
  travel: {
    'abandonedBasket.items.*.product.journey.*.start.where.iataCode': {
      operators: ['=', '!='],
      values: Object.keys(allIataCodes),
      valuesTranslationPrefix: 'journey.iataCodes',
      defaultOperator: '=',
      defaultValue: iataCodes[0],
      filterType: 'array',
    } as FilterOption,
  } as SegmentationOption,
};

export const segmentationOptions: SegmentationOption = {
  behaviours: {
    'customer.loggedIn': {
      operators: [],
      values: ['true', 'false'],
      defaultOperator: '',
      defaultValue: 'true',
      filterType: 'bool',
    } as FilterOption,
    'customer.marketingStatus': defaultStringFilter,
  } as SegmentationOption,
  demographics: {
    'customer.type': defaultStringFilter,
    'phone.mobile': {
      operators: ['exists', '!exists'],
      values: [],
      defaultOperator: 'exists',
      defaultValue: 'true',
      filterType: 'string',
    },
  } as SegmentationOption,
  eCommerce: {},
  geography: {
    'geoLocation.countryCode': {
      operators: ['=', '!='],
      values: Object.keys(allCountries),
      valuesTranslationPrefix: 'geolocation.countryNames',
      defaultOperator: '=',
      defaultValue: countryCodes[0],
      filterType: 'array',
    } as FilterOption,
  } as SegmentationOption,
  legacy: {
    sendOverride: defaultStringFilter,
  } as SegmentationOption,
  technology: {
    'device.device.type': {
      operators: ['=', '!='],
      values: ['mobile', 'desktop'],
      defaultOperator: '=',
      defaultValue: 'mobile',
      filterType: 'array',
    } as FilterOption,
  } as SegmentationOption,
  AI: {
    smartSegmentation: {
      operators: ['=', '!='],
      values: ['0', '1', '2', '3', '4'],
      defaultOperator: '=',
      defaultValue: '0',
      filterType: 'array',
    } as FilterOption,
  } as SegmentationOption,
};

// This flattens the segmentationOptions-like multi level object tree into a 1 level deep string keyed object
export const listAllFilterOptions = (segmentationOptionsInput: object): { [key: string]: FilterOption } => {
  const filterOps = {};
  const recursiveFind = (options: object) => {
    Object.keys(options).forEach(key => {
      if (instanceOfFilterOption(options[key])) {
        filterOps[key] = options[key];
        return;
      }
      recursiveFind(options[key]);
    });
  };
  recursiveFind(segmentationOptionsInput);
  return filterOps;
};

export const segmentationBasketOptions = {
  ...segmentationOptions,
  eCommerce: basketECommerce,
};
export const segmentationBrowseOptions = {
  ...segmentationOptions,
  eCommerce: browseECommerce,
};
export const segmentationPurchaseOptions = {
  ...segmentationOptions,
  eCommerce: purchaseECommerce,
};
// TODO used in SegmentFilterList to render the right values. Look how to use the onsite shared component
export const segmentationBrowseOptionList = listAllFilterOptions(segmentationBrowseOptions);
export const segmentationOptionList = listAllFilterOptions({
  ...segmentationOptions,
  eCommerce: mutualeCommerce,
});
export const segmentationCardAbandOptionList = listAllFilterOptions(segmentationBasketOptions);
